import core, { App, Poller } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { useMemoSelector, useWithLocation } from 'hooks';
import matchList from 'modules/match-list';
import { parse } from 'utils';

const {
    viewport: {
        selectors: { selectIsCompact },
    },
    utils: { getBettingOptions },
} = core;
const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    pagination: {
        selectors: { selectIsPollingTurnedOff },
    },
} = matchList;

const POLLER_NAME = App.PollerName.Upcoming;

interface Output {
    shouldRenderMobileTopMatches: boolean;
    fetchStatus: App.FetchStatus;
    pollerOpts: Poller.UsePollerInput<typeof searchMatches>;
}

const useUpcoming = (): Output => {
    const { isBettingPage, isTop, location } = useWithLocation(l => ({
        isTop: parse(l.search).isTop,
        isBettingPage: getBettingOptions().url.pagePath === '',
        location: l,
    }));

    const {
        fetchStatus,
        isPollingTurnedOff,
        isMedium,
    } = useMemoSelector(selectProps, { location }); // NOTE selectIsPollingTurnedOff need of location

    const shouldRenderMobileTopMatches = !!isTop && isBettingPage && isMedium;

    const isPollingTurnedOffByPlatform =
        !shouldRenderMobileTopMatches && isPollingTurnedOff;

    return {
        fetchStatus,
        shouldRenderMobileTopMatches,
        pollerOpts: {
            pollerName: POLLER_NAME,
            executableAction: searchMatches,
            isPollingTurnedOff: isPollingTurnedOffByPlatform,
        },
    };
};

const selectProps = createStructuredSelector({
    isPollingTurnedOff: selectIsPollingTurnedOff,
    fetchStatus: selectFetchStatus,
    isMedium: selectIsCompact,
});

export default useUpcoming;
